import store from './store/'

import InitialAssessment from './components/assessment_cycle/InitialAssessment.vue'
const initialApp = Vue.createApp({}).use(store)
initialApp.component('initial-assessment', InitialAssessment)
initialApp.mount('#initial_assessment')

import QiPlan from './components/assessment_cycle/QiPlan.vue'
const qiApp = Vue.createApp({}).use(store)
qiApp.component('qi-plan', QiPlan)
qiApp.mount('#qi_plan')

import FollowUpAssessment from './components/assessment_cycle/FollowUpAssessment.vue'
const followupApp = Vue.createApp({}).use(store)
followupApp.component('followup-assessment', FollowUpAssessment)
followupApp.mount('#followup_assessment')

import Summary from './components/assessment_cycle/Summary.vue'
const summaryApp = Vue.createApp({}).use(store)
summaryApp.component('summary-app', Summary)
summaryApp.mount('#summary_app')

import GeneralInfo from './components/assessment_cycle/GeneralInfo.vue'
const generalApp = Vue.createApp({}).use(store)
generalApp.component('general-info', GeneralInfo)
generalApp.mount('#general_info')

import GeneralComment from './components/general_comment/GeneralComment.vue'
const commentApp = Vue.createApp({}).use(store)
commentApp.component('general-comment', GeneralComment)
commentApp.mount('#general_comment')
